import { ReactElement } from "react";
import { t } from "@lingui/core/macro";

import * as S from "./styled";

export const LoadingOverlay = (): ReactElement => {
  const loadingText = t`components.loading-overlay.loading`;

  return <S.Overlay>{loadingText}</S.Overlay>;
};
